import { mapState, mapActions } from 'vuex';

export default  {	
	data () {
		return { 
			user: { email: '', password: ''}
		}
	},
	created () { 
		this.updateCrud({state:'namePath', data: 'admin_usuarios'}) 
	},
	computed: { 
	  ...mapState({
		  dataGet       : state => state.crudStore.dataGet, 
	  })   
	},
	methods: {
	  ...mapActions({    
		  login:     'authStore/login',  
	  })
	}
}
